import {
	trim
} from 'lodash';

export default (value, n, c) => {

	if (n === 0) {
		return value;
	}

	let str = trim(value);
	c = c || '...';

	let ext = /&[^;\s]*;/g;
	if (str.match(ext)) {
		for (let i = 0; i < str.match(ext).length; i++) {
			n = n + (str.match(ext)[i].length - 1);
		}
	}

	if (str.length <= n) {
		return str;
	}

	str = str.substr(0, n + 1);
	let p1 = str.lastIndexOf(' '),
		p2 = str.lastIndexOf('\n'),
		p3 = str.lastIndexOf('\t'),
		p4 = str.lastIndexOf('\s'), // eslint-disable-line
		pos = Math.max(p1, p2, p3, p4);

	if (pos > 0) {
		str = str.substr(0, pos);
	}

	str = trim(str);

	return str + c;

};



// WEBPACK FOOTER //
// ./sources/filters/truncate.js